<input
  id="batch-excel"
  type="file"
  multiple="false"
  accept=".xls, .xlsx"
  #fileInput
  (change)="onFileChange($event)"
/>
<button id="loadBatches" (click)="hangleLoadFile()">Cargar lotes</button>

<div class="overlay" *ngIf="customerOverlay">
  <div class="overlay__content" style="padding-bottom: 30px;">
    <h2 class="title">
      <span (click)="togleCustomerOverlay()">
        <app-arrow-back></app-arrow-back>
      </span>
      Clientes
    </h2>
    <div class="container-grid">
      <ng-container *ngFor="let customer of customersWithPieces; index as i">
        <div>
          <label [for]="'customer-' + i" class="form-label">Clientes</label>
          <input
            type="text"
            [id]="'customer-' + i"
            class="form-control"
            [value]="customer.customer_name"
            disabled
          />
        </div>
        <div>
          <label [for]="'material-' + i" class="form-label">Material</label>
          <input
            type="text"
            [id]="'material-' + i"
            class="form-control"
            [value]="customer.material_name"
            disabled
          />
        </div>
        <div>
          <label [for]="'presentation-' + i" class="form-label">Presentación</label>
          <input
            type="text"
            [id]="'presentation-' + i"
            class="form-control"
            [value]="customer.presentation"
            disabled
          />
        </div>
        <div class="sub-container ">
          <div>
            <label [for]="'unidades-' + i" class="form-label"># unidades</label>
            <input
              type="text"
              [id]="'unidades-' + i"
              class="form-control"
              [value]="customer.quantity_pieces | number"
              disabled
            />
          </div>
          <div>
            <label [for]="'bl-' + i" class="form-label">Tonelaje</label>
            <input
              type="text"
              [id]="'bl-' + i"
              class="form-control"
              [value]="customer.tonnage_bl | number : '1.3-3'"
              disabled
            />
          </div>
        </div>
        <div class="form-check">
          <input
            type="radio"
            class="form-check-input"
            [id]="'customer-' + customer.id"
            [value]="customer.id"
            [formControl]="customerId"
          >
        </div>
      </ng-container>
      <div class="grid-all container-button">
        <button
          type="button"
          class="btn-lote me-5"
          (click)="togleCustomerOverlay()"
        >
          Regresar
        </button>
        <button
          type="submit"
          class="btn-lote ms-5"
          (click)="validateCustomerId()"
        >
          Aceptar
        </button>
      </div>
    </div>
  </div>
</div>
<app-overlay
  *ngIf="errorOverlay"
  [icono]="icon"
  [mensaje]="message"
  [buttons]="buttons"
  (onDeleteLote)="closeErrorOverlay()"
></app-overlay>
<app-overlay
*ngIf="loading"
></app-overlay>
